import IconEmptyBox from "assets/images/icons/project-icons/empty-box.png";


const EmptyUI = (props) => {
    const { text, subText } = props;
    
    return (
        <div className="py-10 mx-auto text-center text-base">
            <div className="flex justify-center">
                <img src={IconEmptyBox} alt="Empty" className="h-36" />
            </div>
            <div className="text-[#101828] font-medium">
                {text}
            </div>
            <div className="mt-1">
                {subText}
            </div>
        </div>
    )
}


export default EmptyUI